import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitStatus, setSubmitStatus] = useState('');


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send message');
      }

      setSubmitStatus('success');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Detailed error:', error);
      setSubmitStatus('error');
    }
  };


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Add status message display
  const renderSubmitStatus = () => {
    switch(submitStatus) {
      case 'submitting':
        return <p className="text-blue-600">Sending message...</p>;
      case 'success':
        return <p className="text-green-600">Message sent successfully!</p>;
      case 'error':
        return <p className="text-red-600">Failed to send message. Please try again.</p>;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16 space-y-20">
      {/* Header */}
      <section className="text-center">
        <h1 className="text-4xl font-bold text-teal-600 mb-6">Contact Us</h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Get in touch with us to learn how we can help extend your team and optimize your operations.
        </p>
      </section>

      <div className="grid md:grid-cols-2 gap-12">
        {/* Contact Information */}
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold mb-2">Email:</h3>
                <p className="text-gray-600">contact@infaisystems.com</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Phone:</h3>
                <p className="text-gray-600">USA: +1 916 586 4132</p>
                <p className="text-gray-600">India: +91 99208 70990</p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-4">Our Locations</h2>
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold mb-2 flex items-center">
                  <span className="mr-2 text-xl">🇺🇸</span> USA Office:
                </h3>
                <p className="text-gray-600">
                  4603 Scenic Vista Drive<br />
                  Folsom, CA, 95630<br />
                  United States
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-2 flex items-center">
                  <span className="mr-2 text-xl">🇮🇳</span> India Office:
                </h3>
                <p className="text-gray-600">
                  Neelkanth Business Park<br />
                  5th Floor, D514, Vidyavihar West<br />
                  Mumbai 400086, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white p-8 rounded-lg shadow-sm">
          <h2 className="text-2xl font-bold mb-6">Send us a Message</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  First Name*
                </label>
                <input
                  type="text"
                  name="firstName"
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  onChange={handleChange}
                  value={formData.firstName}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Last Name*
                </label>
                <input
                  type="text"
                  name="lastName"
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  onChange={handleChange}
                  value={formData.lastName}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email*
              </label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                onChange={handleChange}
                value={formData.email}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                onChange={handleChange}
                value={formData.phone}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Subject*
              </label>
              <input
                type="text"
                name="subject"
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                onChange={handleChange}
                value={formData.subject}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Message*
              </label>
              <textarea
                name="message"
                required
                rows="4"
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                onChange={handleChange}
                value={formData.message}
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={submitStatus === 'submitting'}
              className="w-full bg-teal-600 text-white py-3 px-6 rounded-lg hover:bg-teal-700 transition-colors disabled:bg-gray-400"
            >
              {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>

            {renderSubmitStatus()}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
